<template>
    <div>

        <p v-show="!rows.length">
            {{ lang.polaris.form.currently_no_file }}
        </p>
        
        <trax-ui-simple-table :id="id" :header="0" :rows="rows" :cols="cols" :bus="bus" v-show="rows.length">
        </trax-ui-simple-table>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            endpoint: null,
            bus: null,
            editing: null,
            autoload: null
        },

        data: function() {
            var cols = [{width: '30px', class: 'text-left'}, {}];
            if (this.editing) cols.push({width: '20px', padding: '0px', class: 'text-right commands'});
            return {
                lang: lang,
                files : null,
                cols: cols,
                rows: [],
                loaded: false
            }
        },

        created: function() {
            this.bus.$on(this.id+'-disable-files', this.disableFiles);
            this.bus.$on(this.id+'-load-files', this.loadFiles);
            this.bus.$on(this.id+'-edit-created', this.loadFiles);
            this.bus.$on(this.id+'-delete-confirmed', this.deleteFileConfirmed);
            if (this.autoload) this.loadFiles();
        },

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on( 'click', '.btn.delete', function() {
                that.deleteFile($(this).data('id'));
            });

        },
        
        methods: {
        
            deleteFile: function(id) {
                this.bus.$emit(this.id+'-delete-open', {data: id});
            },

            disableFiles: function() {
                $('#'+this.id+'-table tbody td.commands').hide();
            },

            deleteFileConfirmed: function(id) {
                var that = this;
                axios.delete(this.endpoint+'/'+id)
                    .then(function (response) {
                        that.loadFiles();
                    })
                    .catch(function (error) {
                    });
            },

            loadFiles: function() {
                var that = this;
                axios.get(this.endpoint)
                    .then(function (response) {
                        that.loaded = true;
                        that.files = response.data.data;
                        that.updateRows();
                    })
                    .catch(function (error) {
                    });
            },

            updateRows: function() {
                this.rows = [];
                for (var index in this.files) {
                    var file = this.files[index];
                    var row = [this.extension(file), this.name(file)];
                    if (this.editing) row.push(this.commands(file));
                    this.rows.push(row);
                }
            },


            //------------------------------- Columns rendering ----------------------------//


            extension: function(file) {
                var format = file.mime_type.split('/')[1];
                var html = '<span class="badge badge-default">'+format+'</span>';
                return this.link(file, html);
            },

            name: function(file) {
                var html = file.name;
                return this.link(file, html);
            },

            commands: function(file) {
                var html = '<button type="button" class="btn btn-link btn-just-icon mt-0 mb-0 delete" data-id="'+file.id+'">';
                html += '       <i class="material-icons">clear</i>';
                html += '   </button>';
                return html;
            },

            link: function(document, content) {
                var href = this.endpoint + '/' + document.id;
                return '<a href="'+href+'" target="_blank">'+content+'</a>';
            }

        }

    }
</script>
